var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"rounded-lg text-center",class:_vm.classes,attrs:{"type":"button"},on:{"click":function($event){$event.stopPropagation();return _vm.clicked.apply(null, arguments)}}},[_vm._t("iconLeft"),_vm._v(" "+_vm._s(_vm.label)+" "),_vm._t("iconRight")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }